module.exports = __webpack_public_path__ + "img/avatar_default_10.d0a98db3.svg";